import { useReadableEventRefresher as r } from "@zdrbm/zdr-react";
import { useDataGridState as c } from "./index.es762.js";
import { useCell as m } from "./index.es760.js";
function p(e, o) {
  const d = c(), [[l]] = r(d.hoveredRowIndex), { row: t, cell: a } = m(e, o), [[i], [s], [n]] = r(
    t.selected,
    t.valid,
    a.valid
  );
  return l === e || i || !n || !s;
}
export {
  p as useDataGridCellHovered
};
//# sourceMappingURL=index.es763.js.map
